<template>
  <section>
      <iframe src="" ref="modelEngine" class="model_engine"></iframe>
<!--      <EngineView :data="data" :scheduledId="scheduledId" style="height: 763px;"></EngineView>-->
  </section>
</template>

<script>
  import EngineView from "./EngineView";
  export default {
    name: "DetailView",
    components: {EngineView},
    props: {
      data: {},
      scheduledId:null,
      scheduledName:null,
    },
    mounted() {
      let index = this.data.modelUrl.lastIndexOf('/');
      let file = this.data.modelUrl.substring(index+1,this.data.modelUrl.length-4);
      this.$refs.modelEngine.src = "/progressengine?file="+file +"&modelId="+this.data.id +"&scheduledId="+this.scheduledId+"&proId="+this.data.projectId+"&scheduledName="+this.scheduledName;
    }
  }
</script>

<style scoped>
  .model_engine{ border: 0;width: 100%; height: 760px; }
</style>



// WEBPACK FOOTER //
// src/components/progress/DetailView.vue